import ApiRouteProvider from '../route'
import axios from '@axios'
import Cache from "@core/api/request/Cache";

export default {
    getBusinessRoles() {
        return Cache.item('SupplyChain.BusinessRoles', () => {
            return axios.get(ApiRouteProvider.supplyChain.businessRoles());
        }).getPromise();
    },
    getStates() {
        return Cache.item('SupplyChain.States', () => {
            return axios.get(ApiRouteProvider.supplyChain.states());
        }).getPromise();
    },
    getOrganizationCard(id) {
        return axios.get(ApiRouteProvider.supplyChain.organization(id));
    },
    getOrganizations(hierarchy, type = null) {
        return axios.get(ApiRouteProvider.supplyChain.organizations(hierarchy, type));
    },
    exists(supplier) {
        let legalIdentity = null;
        if (supplier.legalIdentity && supplier.legalIdentity.value && supplier.legalIdentity.type) {
            legalIdentity = {
                value: supplier.legalIdentity.value,
                type: supplier.legalIdentity.type.id
            }
        }
        return axios.post(
            ApiRouteProvider.getBaseUrl() + '/supply-chain/suppliers/exists',
            {
                legalIdentity: legalIdentity,
                title: supplier.title,
                domain: supplier.domain
            }
        );
    },
    newSupplier(supplier) {
        return axios.post(
            ApiRouteProvider.supplyChain.newSupplier(),
            supplier
        );
    },
    updateSupplier(supplier) {
        return axios.put(
            ApiRouteProvider.supplyChain.updateSupplier(supplier.id),
            {
                title: supplier.title,
                legalIdentity: supplier.legalIdentity,
                domain: supplier.domain,
                state: supplier.state.id ? supplier.state.id : supplier.state,
                contacts: supplier.contacts,
            }
        );
    },
    newInternalOrganization(organization) {
        return axios.post(
            ApiRouteProvider.supplyChain.newInternalOrganization(),
            organization
        );
    },
    updateInternalOrganization(organization) {
        return axios.put(
            ApiRouteProvider.supplyChain.updateInternalOrganization(organization.id),
            {
                ...organization,
                state: organization.state && organization.state.id ? organization.state.id : organization.state,
            }
        )
    },
    searchSupplier(qs) {
        return axios.get(ApiRouteProvider.supplyChain.searchSupplier(qs));
    },
    getSuppliers(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.supplyChain.getSuppliers({
            filters,
            sort: sorting,
            page,
            perPage
        }))
    },
    searchCustomers(qs) {
        return axios.get(ApiRouteProvider.supplyChain.searchCustomers(qs));
    },
    getCustomers(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.supplyChain.getCustomers({
            filters,
            sort: sorting,
            page,
            perPage
        }))
    },
    getInternalOrganizations(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.supplyChain.getInternalOrganizations({
            filters,
            sort: sorting,
            page,
            perPage
        }))
    }
};
